import Cookies from "js-cookie";

import { CheckoutItemData, CheckoutSession, CheckoutTotal, OrderAmount } from "../types/checkout";
import { get, post, postDontHandleError } from "./fetch.core";

export async function createCheckoutSession(items: CheckoutItemData[]): Promise<string> {
  const res = await post<{ id: string }>("/pos/checkout/createSession", {
    items,
  });

  const sessionId = res.data.id;
  setSessionId(sessionId);
  return sessionId;
}

export async function getPosCheckoutSession() {
  let sessionId = getSessionId();

  const res = await get<CheckoutSession>(`/pos/checkout/getSession?sessionId=${sessionId}`);

  return res.data;
}

export async function calculateTotal(
  items: CheckoutItemData[],
  userId?: String,
  usedReward?: number,
  orderOverrideDiscount?: number
) {
  let sessionId = getSessionId();

  if (!sessionId) {
    sessionId = await createCheckoutSession(items);
  }

  const res = await post<CheckoutTotal>(`/pos/checkout/calculateTotal?sessionId=${sessionId}`, {
    frontUserId: userId,
    items,
    orderOverrideDiscount,
    usedReward,
  });
  return res.data;
}

export async function calculateOnlineTotal(
  userId: string,
  countryId: string,
  shipId: string,
  usedReward: number,
  hkRegionId?: string
) {
  const sessionId = Cookies.get("sessionId");

  let url = `/public/checkout/calculateTotal?sessionId=${sessionId}&countryId=${countryId}&shipOptionId=${shipId}&usedReward=${usedReward}`;
  if (hkRegionId) url = url + `&hkRegionId=${hkRegionId}`;

  const res = await get<OrderAmount>(url, { useUserId: userId });

  return res.data;
}

export async function addCoupon(couponCode: String, userId: String) {
  let sessionId = getSessionId();

  const res = await postDontHandleError<{ msg: string }>(`/pos/checkout/addCoupon`, {
    couponCode,
    frontUserId: userId,
    id: sessionId,
  });

  return res;
}

export async function removeCoupon(couponId: String, userId: String) {
  let sessionId = getSessionId();

  const res = await post<CheckoutTotal>(`/pos/checkout/removeCoupon`, {
    couponId,
    frontUserId: userId,
    id: sessionId,
  });
  return res.data;
}

export async function removeAllCoupons() {
  let sessionId = getSessionId();

  const res = await get<{ message: string }>(`/pos/checkout/removeAllCoupons?id=${sessionId}`);
  return res.data;
}

export async function addGiftCard(giftCardCode: String, userId: String) {
  let sessionId = getSessionId();

  const res = await postDontHandleError<{ msg: string }>(`/pos/checkout/addGiftCard?sessionId=${sessionId}`, {
    giftCardCode,
    frontUserId: userId,
  });

  return res;
}

export async function removeGiftCard(giftCardId: String, userId: String) {
  let sessionId = getSessionId();

  const res = await post<CheckoutTotal>(`/pos/checkout/removeGiftCard?sessionId=${sessionId}`, {
    giftCardId,
    frontUserId: userId,
  });
  return res.data;
}

export async function removeAllGiftCards() {
  let sessionId = getSessionId();

  const res = await get<{ message: string }>(`/pos/checkout/removeAllGiftCards?sessionId=${sessionId}`);
  return res.data;
}

export function getSessionId() {
  return Cookies.get("sessionId");
}

export function setSessionId(sessionId: string) {
  Cookies.set("sessionId", sessionId);
}

async function getOnlineSession(userId: string) {
  const sessionId = Cookies.get("sessionId");
  const res = await get<CheckoutSession>(`/public/checkout/getSession?id=${sessionId}`, { useUserId: userId });

  return res.data;
}

const checkoutCore = {
  getOnlineSession,
};

export default checkoutCore;
